import { useMutation, useQueryClient } from "@tanstack/react-query";
import { enqueueSnackbar } from "../../../components/GlobalSnackbar/snackbarStore";
import { apiClient } from "@copro/api";
import { keys } from "./keys";

async function archiveTopic(id: string) {
  const { error } = await apiClient
    .from('topics')
    .update({
      archived: true
    })
    .eq('id', id)

  if (error) {
    throw error
  }
}

export function useArchiveTopic() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (topicId: string) => archiveTopic(topicId),
    onSuccess: (_data, topicId) => {
      enqueueSnackbar('Sujet archivé.', 'success');

      queryClient.invalidateQueries({ queryKey: keys.topicListArchivedOrNot(false) })
      queryClient.invalidateQueries({ queryKey: keys.topicListArchivedOrNot(true) })
      queryClient.invalidateQueries({ queryKey: keys.topicListPagedAll() })
      queryClient.invalidateQueries({ queryKey: keys.topic(topicId) })
      queryClient.invalidateQueries({ queryKey: keys.subTopicList() })
    }
  })
}
